import { render } from "./PatientDetailsPage.vue?vue&type=template&id=fbb977e2&ts=true"
import script from "./PatientDetailsPage.vue?vue&type=script&lang=ts"
export * from "./PatientDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__